import { get } from 'lodash';
import ApiResources from '@core/data/apiResources';
import MockApiResources from '@core/data/apiResources-mock';

// flags
const useMocks = process.env.USE_MOCKS || location.href.includes('mockoon=true') || false;
const apiResourcesMap = useMocks ? MockApiResources : ApiResources;

const getUrlResolver = () => window.LE.urlResolver;

function resolveUrl(resource, params) {
  const apiResource = get(apiResourcesMap, resource.URL_KEY());
  const baseURL = getUrlResolver().getUrl(apiResource, params);
  return {
    baseURL,
    apiResource,
  };
}

function getUrlParts(url) {
  return getUrlResolver().getUrlParts(url);
}

const CONFIG = {
  useMocks,
};

export const urlResolver = {
  CONFIG,
  getUrlResolver,
  resolveUrl,
  getUrlParts,
};

// TODO add resolver to the BaseClient class to be single source
